module.exports = __webpack_public_path__ + "d4a647494177db79d337cfd40766d918.png";